
/**
 * The inbox keeps its filters in the URL, so returning from an approval page has to reproduce them
 * rather than rebuild a bare inbox URL. They travel to the approval page under a prefix to stay
 * clear of that page's own query params, and are stripped back off on the way home.
 *
 * Prefixing rather than listing the filters by name is what keeps the four approval pages out of
 * this: a new inbox filter is carried across without any of them changing.
 */
const BACK_LINK_PREFIX = 'backLink';

/** Inbox filter params -> prefixed params for the approval page URL. Empty values are dropped. */
export const buildWorkflowBackParams = (filters: any): any => {
  const params: any = {};

  Object.keys(filters || {}).forEach((key) => {
    const value = filters[key];

    // The inbox uses null to mean "drop this param" when it merges into its own URL. Here there is
    // nothing to merge into, so an empty filter is simply left out.
    if (value === null || value === undefined || value === '') {
      return;
    }

    params[BACK_LINK_PREFIX + key.charAt(0).toUpperCase() + key.slice(1)] = value;
  });

  return params;
};

/** Prefixed params off the approval page URL -> inbox filter params. */
export const readWorkflowBackParams = (queryParams: any): any => {
  const params: any = {};

  Object.keys(queryParams || {}).forEach((key) => {
    if (key.indexOf(BACK_LINK_PREFIX) !== 0 || key === BACK_LINK_PREFIX) {
      return;
    }

    const name = key.slice(BACK_LINK_PREFIX.length);
    params[name.charAt(0).toLowerCase() + name.slice(1)] = queryParams[key];
  });

  return params;
};

export const hasWorkflowBackParams = (params: any): boolean => {
  return !!params && Object.keys(params).length > 0;
};
